import React, { useEffect, useState } from 'react'
import Link from 'components/elements/Link'
import { useCookies } from 'react-cookie'

import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_DECK_STATE } from 'redux/deck/actions/types'

import CategoryService from 'services/category.service'
import ToastService from 'services/toast.service'

import { CategoryType } from 'types/deck'

import LineLoader from 'components/elements/LineLoader'
import CategoryTable from 'components/misc/CategoryTable'

import style from './categoryTemplateDeckSettings.module.scss'

const CategoryTemplateDeckSettings = () => {
  const [loading, setLoading] = useState(true)
  const [templates, setTemplates] = useState(new Array<CategoryType>())
  const [error, setError] = useState(null)

  const [{ tbId: userId }] = useCookies(['tbId'])

  const categories = useAppSelector(state => state.deck.categories)

  const [setDeckState] = useActionless(SET_DECK_STATE)

  useEffect(() => {
    CategoryService.listTemplates(userId)
      .then(setTemplates)
      .catch(setError)
      .finally(() => setLoading(false))
  }, [])

  const handleAddTemplate = (template: CategoryType) => {
    return CategoryService.create(template)
      .then(res => {
        const updatedCategories = { ...categories }

        updatedCategories[res.name] = res

        setDeckState({ categories: updatedCategories })
      })
      .catch(err => ToastService.create(err))
  }

  let content = null

  const unusedTemplates = templates.reduce((acc, template) => {
    if (!categories[template.name]) acc.push(template)

    return acc
  }, new Array<CategoryType>())

  if (!unusedTemplates.length) content = <div>All Category Templates are already being used in this deck</div>
  if (unusedTemplates.length) content = <CategoryTable categories={unusedTemplates} onTemplateAdd={handleAddTemplate} />

  if (!templates.length) content = <div>You have no Category Templates</div>
  if (loading) content = <LineLoader />
  if (error) content = <div>Unable to load category templates</div>

  return (
    <div>
      <h4>Category Templates</h4>
      <p>
        You can manage your Category Templates in your{' '}
        <Link className={style.link} href="/accountSettings/category-templates">
          Account Settings
        </Link>
      </p>
      {content}
    </div>
  )
}

export default CategoryTemplateDeckSettings
